import {UseFileInfo, UseModel} from "../../function/hooks/useDataFromRedux"
import React from "react"
import Styles from "./upload.less"
import UploadFile from "./uploadFile/uploadFile"
import vsImg from "../../static/pic/vs.svg"
import {connect, useDispatch} from "react-redux"
import ShowDataList from "../../function/hooks/showDataList"
import {outputMsg} from "../../action/global"
import {ReducerState} from "../../reducer/interface/baseInterface"

const Upload = () => {
    const dispatch = useDispatch()
    const model = UseModel()
    const showDataList = ShowDataList()
    const [baseInfo, compareInfo] = [UseFileInfo().useNewBase(), UseFileInfo().useNewCompare()]
    const startComparison = () => {
        const canBeCompare = baseInfo.status === "success" && compareInfo.status === "success"
        if (canBeCompare) {
            dispatch({type: "fileNewToDisplayAndLast", payload: "fileNewToDisplayAndLast"})
            showDataList.toTrue()
            dispatch({type: "activeView", payload: "display"})
            dispatch({type: "startLoading", payload: true})
            model.invokeAsync("startComparison", {
                baseFile: {
                    fileName: baseInfo.name,
                    url: baseInfo.url,
                    tempFileId: baseInfo.tempFileId,
                },
                compareFile: {
                    fileName: compareInfo.name,
                    url: compareInfo.url,
                    tempFileId: compareInfo.tempFileId,
                },
            })
        } else {
            dispatch(outputMsg(`文件上传失败或文件缺失`))
        }
    }
    const renderUpload = () => {
        return (
            <div className={Styles.uploadBox}>
                <UploadFile type={"Base"} fileInfo={baseInfo} />
                <div className={Styles.startCompare}>
                    <img style={{width: 36, height: 36}} alt={""} src={vsImg} />
                    <div className={Styles.compareBox}>
                        <div onClick={() => startComparison()} className={Styles.comparison}>
                            开始比对
                        </div>
                    </div>
                </div>
                <UploadFile type={"Compare"} fileInfo={compareInfo} />
            </div>
        )
    }
    return <div className={Styles.upload}>{renderUpload()}</div>
}

export default connect((state: ReducerState) => {
    return {
        viewType: state.global.viewType,
        loading: state.control.loading,
        comparisonStatus: state.control.comparisonStatus,
    }
})(Upload)
